module.exports = "/_next/static/images/va-info-image-b9a9153e2f080d6426b453028dd375ec.svg";